import { Carousel } from "antd";
import MainLayout from "../layouts/MainLayout";
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from "react-redux";
import { getSiteSettings } from "../redux/actions/siteSettings";
import { useEffect } from "react";
import { getPost } from "../redux/actions/post";
import PostCard from "../components/PostCard";
import { getProducts } from "../redux/actions/product";
import ProductCard from "../components/ProductCard";
const Home = () => {
  const { siteSettings } = useSelector((state: any) => state.siteSettings);
  const { posts } = useSelector((state: any) => state.posts);
  const { products } = useSelector((state: any) => state.products);

  const slides = siteSettings?.slides;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch<any>(getSiteSettings());
    dispatch<any>(getPost());
    dispatch<any>(getProducts());
  }, [dispatch]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true
  };

  const responsive = [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10px'
      }
    }
  ]

  console.log(posts);

  return (
    <MainLayout>
      <Helmet>
        <title>Anasayfa | Sakarya Lastik - İş Makinesi ve Kamyon Lastikleri</title>
        <meta name="description" content="Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
        <meta name="keywords" content="sakarya lastik, iş makinesi lastiği, kamyon lastiği, lastik tamiri, lastik bakımı, lastik satışı, sakarya lastikçi, iş makinesi lastik servisi" />
        <meta property="og:title" content="Anasayfa | Sakarya Lastik - İş Makinesi ve Kamyon Lastikleri" />
        <meta property="og:description" content="Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
        <meta property="og:type" content="website" />
      </Helmet>
      {
        siteSettings && <Carousel {...settings} className="shadow-xl drop-shadow-2xl">
          {
            slides?.map((item: any, index: number) => (
              <div key={index}>
                <img src={item} alt={item} />
              </div>
            ))
          }
        </Carousel>
      }
      <div className="container mx-auto !mt-20">
            <div className="justify-center mb-20">
              <div className="col-lg-6"><div className="title-area text-center">
                <span className="sub-title">Tamir ve Bakım Süreçlerimiz</span>
                <h2 className="sec-title">Güvenilir Araç Lastik Tamirinde En İyi Çözümler</h2>
              </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="col-lg-4 process-card-wrap">
                <div className="process-card">
                  <div className="process-card-icon">
                    <img src="/images/process-icon-1-1.svg" alt="Altun Oto Lastik" />
                  </div><h4 className="process-card-title">Mobil Lastik Tamiri</h4>
                  <p className="process-card-text">7/24 Adapazarı, Sapanca, Kocaeli ve Kuzey Marmara Oto Yolu civarlarında size hizmete hazırız.</p>
                </div>
              </div>
              <div className="col-lg-4 process-card-wrap">
                <div className="process-card process-card-center">
                  <div className="process-card-icon">
                    <img src="/images/process-icon-1-2.svg" alt="Altun Oto Lastik" />
                  </div>
                  <h4 className="process-card-title">Profesyonel Ekip ve Ustalarımız</h4>
                  <p className="process-card-text">Profesyonel ve Deneyimli ekibimiz size en kısa sürede ulaşıp, modern ve teknolojik ekipmanlarımızla en kısa sürede sizi yolunuza uğurlayacaktır.</p>
                </div>
              </div>
              <div className="col-lg-4 process-card-wrap"><div className="process-card">
                <div className="process-card-icon">
                  <img src="/images/process-icon-1-3.svg" alt="Altun Oto Lastik" />
                </div>
                <h4 className="process-card-title">Sakarya İş Makinası Lastikleri</h4>
                <p className="process-card-text">Ağır Vasıta araçlarınız için lastik tamiri ve değişim işlemlerini 7/24 hizmet prensibiyle gerçekleştiriyoruz. Aradığınız lastiğin özellikleri ve lastik fiyatları hakkında bilgi alabilirsiniz.</p>
              </div>
              </div>
          </div>
        <h1 className="text-2xl font-bold mt-10 ">Blog | <small>Son Güncellemelerimizden Haberdar Olun</small></h1>
        <div className="mt-5">
          <Carousel
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={5}
            slidesToScroll={1}
            autoplay={false}
            autoplaySpeed={5000}
            arrows={true}
            responsive={responsive}
          >
            {posts?.map((item: any, index: number) => (
              <div key={index} className="px-2 mb-5 pb-5">
                <PostCard post={item} />
              </div>
            ))}
          </Carousel>
        </div>
        <h1 className="text-2xl font-bold mt-10 ">Ürünler | <small>Sizin İçin Seçtiklerimiz</small></h1>
        <div className="mt-5">
          <Carousel
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={5}
            slidesToScroll={1}
            autoplay={false}
            autoplaySpeed={5000}
            arrows={true}
            responsive={responsive}
          >
            {products?.map((item: any, index: number) => (
              <div key={index} className="px-2 mb-5">
                <ProductCard product={item} />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </MainLayout>
  );
}

export default Home;